// @flow

import { type ConfirmedIncomingPayment, type PendingIncomingPayment } from './types';

export function getMustRedirectAfterPaymentConfirmed(incomingPayment: ConfirmedIncomingPayment|PendingIncomingPayment): boolean {
  return !!incomingPayment['must_redirect_after_payment_confirmed'];
}
